import TourPage from "@/components/TourPage";

export default function UgandaAdventure8Day() {
  return (
    <TourPage
      tourId="uganda/adventure-8-day"
      title="8-Day Uganda Adventure Safari"
      duration="8 Days / 7 Nights"
      price="Contact for price"
      image="/gorillabwindi.jpg"
      description="Experience the ultimate Uganda adventure with this comprehensive 8-day safari covering multiple national parks, offering diverse wildlife encounters and breathtaking landscapes."
      itinerary={[
        {
          day: 1,
          title: "Arrival in Entebbe",
          description: "Welcome to Uganda, the Pearl of Africa.",
          activities: [
            "Airport pickup",
            "Transfer to hotel in Entebbe",
            "Safari briefing",
            "Evening relaxation"
          ],
          accommodation: "Protea Hotel or similar",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Ziwa Rhino Sanctuary - Murchison Falls",
          description: "Track rhinos and visit the magnificent falls.",
          activities: [
            "Rhino tracking at Ziwa Sanctuary",
            "Drive to Murchison Falls National Park",
            "Evening game drive"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Murchison Falls Experience",
          description: "Game drives and boat cruise.",
          activities: [
            "Morning game drive",
            "Afternoon boat cruise to the falls base",
            "Hike to the top of the falls"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Transfer to Kibale Forest",
          description: "Journey to the primate capital.",
          activities: [
            "Drive to Kibale Forest National Park",
            "Visit tea plantations en route",
            "Evening nature walk"
          ],
          accommodation: "Primate Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Chimpanzee Tracking",
          description: "Track our closest relatives.",
          activities: [
            "Chimpanzee tracking in Kibale Forest",
            "Afternoon Bigodi Wetland walk",
            "Cultural village visit"
          ],
          accommodation: "Primate Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Queen Elizabeth National Park",
          description: "Big game viewing in Queen Elizabeth.",
          activities: [
            "Transfer to Queen Elizabeth National Park",
            "Afternoon game drive",
            "Evening boat cruise on Kazinga Channel"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Tree-climbing Lions",
          description: "Search for tree-climbing lions.",
          activities: [
            "Game drive in Ishasha sector",
            "Search for tree-climbing lions",
            "Afternoon game viewing"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Return to Entebbe",
          description: "Journey back to Entebbe.",
          activities: [
            "Morning game drive",
            "Drive back to Entebbe",
            "Departure"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Airport transfers",
        "Transportation in 4x4 safari vehicle",
        "English-speaking guide",
        "Park entrance fees",
        "Boat cruises",
        "Game drives",
        "Chimpanzee permit",
        "Accommodation as listed",
        "Meals as specified"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities"
      ]}
    />
  );
}
